import { Button } from "@chakra-ui/button";
import { FormControl, FormLabel } from "@chakra-ui/form-control";
import { Input, InputGroup, InputRightElement } from "@chakra-ui/input";
import { VStack, HStack, Text } from "@chakra-ui/layout";
import { useToast } from "@chakra-ui/react";
import axios from "axios";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { ChatState } from "../../Context/ChatProvider";
import VerifyOtp from "./VerifyOtp";
import ForgotPassword from "./ForgotPassword";

const Login = () => {
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);
  const toast = useToast();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [pendingEmail, setPendingEmail] = useState("");
  const [devPreview, setDevPreview] = useState("");
  const [forgotMode, setForgotMode] = useState(false);

  const history = useHistory();
  const { setUser } = ChatState();

  const submitHandler = async () => {
    setLoading(true);
    if (!email || !password) {
      toast({
        title: "Please Fill all the Fields",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setLoading(false);
      return;
    }

    try {
      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };

      const { data } = await axios.post(
        "/api/user/login",
        { email, password },
        config
      );

      toast({
        title: "Login Successful",
        description: `Welcome back, ${data.name.split(" ")[0]}. Let's talk fast.`,
        status: "success",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setUser(data);
      localStorage.setItem("userInfo", JSON.stringify(data));
      setLoading(false);
      history.push("/chats");
    } catch (error) {
      const payload = error.response?.data || {};
      if (
        error.response?.status === 403 &&
        payload.code === "EMAIL_NOT_VERIFIED"
      ) {
        setPendingEmail(payload.email || email.trim().toLowerCase());
        setDevPreview(payload.devPreviewOtp || "");
        toast({
          title: "Verify your email",
          description:
            payload.message ||
            "Your email isn't verified yet — enter the code we sent you.",
          status: "warning",
          duration: 6000,
          isClosable: true,
          position: "bottom",
        });
        setLoading(false);
        return;
      }
      toast({
        title: "Error Occured!",
        description: payload.message || error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setLoading(false);
    }
  };

  const onOtpVerified = (data) => {
    setUser(data);
    localStorage.setItem("userInfo", JSON.stringify(data));
    history.push("/chats");
  };

  if (pendingEmail) {
    return (
      <VerifyOtp
        email={pendingEmail}
        devPreviewOtp={devPreview}
        onBack={() => setPendingEmail("")}
        onVerified={onOtpVerified}
      />
    );
  }

  if (forgotMode) {
    return (
      <ForgotPassword
        initialEmail={email}
        onBack={() => setForgotMode(false)}
        onDone={() => setForgotMode(false)}
      />
    );
  }

  return (
    <VStack
      spacing="14px"
      align="stretch"
      as="form"
      onSubmit={(e) => {
        e.preventDefault();
        submitHandler();
      }}
    >
      <FormControl id="email" isRequired>
        <FormLabel className="auth-label">Email Address</FormLabel>
        <Input
          className="auth-input"
          value={email}
          type="email"
          placeholder="you@electric.com"
          onChange={(e) => setEmail(e.target.value)}
        />
      </FormControl>
      <FormControl id="password" isRequired>
        <HStack justify="space-between" align="center" mb="8px">
          <FormLabel className="auth-label" mb="0 !important" m="0">
            Password
          </FormLabel>
          <Text
            fontSize="12px"
            color="cyan.300"
            fontWeight="600"
            cursor="pointer"
            _hover={{ color: "white" }}
            onClick={() => setForgotMode(true)}
            as="button"
            type="button"
          >
            Forgot?
          </Text>
        </HStack>
        <InputGroup size="md" className="auth-input-wrap">
          <Input
            className="auth-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type={show ? "text" : "password"}
            placeholder="••••••••••"
            pr="4.8rem"
          />
          <InputRightElement width="4.5rem" h="100%">
            <Button className="show-btn" h="1.75rem" size="sm" onClick={handleClick}>
              {show ? "Hide" : "Show"}
            </Button>
          </InputRightElement>
        </InputGroup>
      </FormControl>
      <Button
        className="auth-submit"
        width="100%"
        style={{ marginTop: 18 }}
        type="submit"
        isLoading={loading}
        loadingText="Entering the room…"
      >
        Login →
      </Button>
    </VStack>
  );
};

export default Login;
